import React from 'react'
import './extras-warning-popup.css'

const ExtrasWarningPopup = (props) => {

    const tryToClose = (id) => {
        if(id === 'extras-warning-popup__wrapper') {
            props.setOpenExtrasWarning(false)
        }
    }

    return(
        <div className='extras-warning-popup__wrapper' id='extras-warning-popup__wrapper' onClick={(e) => tryToClose(e.target.id)}>
            <div className='extras-warning-popup'>
                <div className='extras-explaination-header'>Extras Warning</div>
                <div className='extras-explaination-section'>It looks like this invoice has some Extras. These Extras will <strong>not</strong> be automatically added to Wave:</div>
                {props.extras.map((extra) => 
                    <div className='extras-list-wrapper'>
                        <div className='specific-extra'>${extra.amount} for {extra.description}</div>
                    </div>
                )}
                <div className='extras-explaination-section-2'>If this is something the family should be charged for, make sure to manually add it to the Wave Invoice.</div>
                <div className='continue-submitting-invoice-btn' onClick={() => props.closeExtrasPopupAndSubmitInvoiceToWave()}>Continue Sending Invoice To Wave</div>
            </div>
        </div>
    )
}
export default ExtrasWarningPopup;